import { useEffect, useState } from "react";
import { FontIcon, initializeIcons, Label, PrimaryButton, Stack, TextField } from "@fluentui/react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TLogin, TLoginState } from "../constants/types";
import styles from "../styles/admin.module.scss";
import cookie from 'react-cookies';

export interface ILoginProps {
}

const LoginCreate : React.FunctionComponent<ILoginProps> = (props : ILoginProps) => {
    const [password, setpassword] = useState<string>("");
    const [username, setusername] = useState<string>("");
    const [password2, setpassword2] = useState<string>("");
    const [validated, setvalidated] = useState<boolean>(false);
    const [token, settoken] = useState<string>("326f01d34cb649d591fc9671fc2b0565b8ee3142690c4c2091646dbf858579f2");
    const [vallidateErrors, setVallidateErrors] = useState<string[]>([]);
    const [pwdsameerror, setpwdsameerror] = useState<string>("");
    const [pwd1view, setpwd1view] = useState<boolean>(false);
    const [pwd2view, setpwd2view] = useState<boolean>(false);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [site, setsite] = useState<string>();
    const [dev, setdev] = useState<boolean>(false);
    const [apiUrl, setapiUrl] = useState<string>();

    useEffect(() => {
        let dev = false;
        let selectedSite = "";
        if (document.location.host === "localhost:3000") {
            dev = true;
            selectedSite = "retrocollectie";
        } else {
            selectedSite = document.location.host.split('.')[1];
        }

        let apiUrl =  document.location.origin + "/Backend";
        if (dev) {
            apiUrl = "http://127.0.0.1:36";
        }

        setapiUrl(apiUrl);
        setdev(dev);
        setsite(selectedSite);

        setusername(searchParams.get("username"));
        settoken(searchParams.get("token"));
        initializeIcons();
    },[]);

    function saveAndLogin() {
        const login : TLogin = { username: username,
                                 site: site,
                                 token: token,
                                 password: password };
        fetch(`${apiUrl}/CreateLogin`, {
            method: "Post", 
            mode: "cors", 
            headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Accept-Encoding": "gzip, deflate ,br"
            },
            referrerPolicy: "origin-when-cross-origin", 
            body: JSON.stringify(login), 
        }).then((response) => response.json()).then((data: TLoginState) => {
            if (data.success) {
               cookie.save('token', data.token, { path: '/' });
               cookie.save('username', username, { path: '/' });
               navigate('/admin');
            }
        });
    }

    function validatePassword() {
        let nerrors = [];

        if (password.trim().length === 0)
        {
            nerrors.push("Wachtwoord mag niet leeg zijn");
            setVallidateErrors(nerrors);
        }

        var hasNumber = new RegExp("[0-9]+");
        var hasUpperChar = new RegExp("[A-Z]+");
        var hasMiniMaxChars = new RegExp(".{8,20}");
        var hasLowerChar = new RegExp("[a-z]+");
        var hasSymbols = new RegExp(`[!@#$%^&*()_+=\\[{\\]};:<>|./?,-]`);

        if (!hasNumber.test(password))
        {
            nerrors.push("Het wachtwoord moet minimaal 1 kleine letter bevatten.");
        }
        if (!hasUpperChar.test(password))
        {
            nerrors.push("Het wachtwoord moet minimaal 1 hoofdletter bevatten.");
        }
        if (!hasMiniMaxChars.test(password))
        {
            nerrors.push("Het wachtwoord moet tussen 8 en 20 karakters lang zijn.");
        }
        if (!hasNumber.test(password))
        {
            nerrors.push("Het wachtwoord moet een nummer bevatten.");
        }
        if (!hasSymbols.test(password))
        {
            nerrors.push("Het wachtwoord moet een speciaal karakter bevatten (!@#$%^&*).");
        }
        
        setVallidateErrors(nerrors);
        if (nerrors.length) {
            setvalidated(false);
        } else {
            setvalidated(true);
        }
    }

    function disablesave() : boolean {
        if (pwdsameerror.length > 0) {
            return true;
        }
        if (vallidateErrors.length > 0) {
            return true;
        }
        if (password !== password2) {
            return true;
        }
        return false;
    }

    function validate2ndPassword() {
        if (password !== password2) {
            setpwdsameerror("Wachtwoorden niet het zelfde.")
        } else {
            setpwdsameerror("");
        }
    }

    return (
        <Stack horizontalAlign="center" style={{height:"100%"}}>
            <Stack style={{maxWidth:350,marginTop:"10%"}}>
                <h2>Nieuw wachtwoord</h2>
                <TextField disabled label="Gebruikersnaam" value={username} />
                <Label>Wachtwoord</Label>
                <Stack horizontal verticalAlign="center" className={styles.nieuwwwcontainer}>
                    <TextField style={{width:"100%"}} type={pwd1view ? "text" : "password"} value={password} onChange={(e,v) => {setpassword(v); }} onBlur={() => {validatePassword();}} />
                    <FontIcon style={{marginLeft:"-22px", zIndex:2, cursor:"pointer"}} aria-label="Hide" iconName={pwd1view ? "Hide" : "View"} onClick={() => {setpwd1view(!pwd1view); }} />
                </Stack>
                {vallidateErrors.map(error => {
                    return <span style={{color:"red"}}>{error}</span>
                })}
                <Label>Type uw wachtwoord nogmaals</Label>
                <Stack horizontal verticalAlign="center" className={styles.nieuwwwcontainer}>
                    <TextField style={{width:"100%"}} type={pwd2view ? "text" : "password"} value={password2} onChange={(e,v) => {setpassword2(v); }} onBlur={() => { validate2ndPassword(); }}/>
                    <FontIcon style={{marginLeft:"-22px", zIndex:2, cursor:"pointer"}} aria-label="Hide" iconName={pwd2view ? "Hide" : "View"} onClick={() => {setpwd2view(!pwd2view); }} />
                </Stack>
                {pwdsameerror.length !== 0 ? <></> : <span style={{color:"red"}}>{pwdsameerror}</span>}
                <br />
                <Stack horizontalAlign="end" className={styles.nieuwwwcontainer}>
                    <PrimaryButton disabled={disablesave()} text="Opslaan" onClick={saveAndLogin} style={{width:"100%"}}/>
                </Stack>
            </Stack>
        </Stack>
    );
}

export default LoginCreate;